// import style from './Login.module.css';
import LoginComponent from "../../components/Login/login";
const Login = () => {
  return (
    <>
      {/* <div className={style.container}> */}

      <LoginComponent />
      {/* </div> */}
    </>
  );
};

export default Login;
